/* ==========================================================================
   PORTFOLIO LIGHTBOX
   The one piece of the retired Angular app that genuinely needed script.
   Tabs are CSS radios; this only opens a <dialog> on a thumbnail click.
   ========================================================================== */
(function () {
  var dialog = document.getElementById('pm-lightbox');
  if (!dialog || !dialog.showModal) return;

  var img = dialog.querySelector('.pm-lightbox__img');
  var cat = dialog.querySelector('.pm-lightbox__cat');
  var title = dialog.querySelector('.pm-lightbox__title');
  var link = dialog.querySelector('.pm-lightbox__link');

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-pm-lightbox-close]');
    if (close) {
      dialog.close();
      return;
    }

    var trigger = e.target.closest('[data-pm-lightbox]');
    if (trigger) {
      img.src = trigger.dataset.src;
      img.alt = (trigger.dataset.title || '') + ' screenshot';
      cat.textContent = trigger.dataset.category || '';
      title.textContent = trigger.dataset.title || '';
      if (trigger.dataset.link) {
        link.href = trigger.dataset.link;
        link.hidden = false;
      } else {
        link.hidden = true;
      }
      dialog.showModal();
      return;
    }

    // Click on the backdrop (the dialog element itself) closes it.
    if (e.target === dialog) dialog.close();
  });
})();

/* --------------------------------------------------------------------------
   PAGINATION
   Rows are all rendered server-side (good for crawlers and for no-JS); this
   only hides the ones off the current page and builds the pager.
   -------------------------------------------------------------------------- */
(function () {
  document.querySelectorAll('[data-pm-paginate]').forEach(function (panel) {
    var perPage = parseInt(panel.dataset.pmPaginate, 10) || 10;
    var rows = Array.prototype.slice.call(panel.querySelectorAll('.pm-work__row'));
    var pager = panel.querySelector('.pm-work__pager');
    if (!pager || rows.length <= perPage) return;

    var pages = Math.ceil(rows.length / perPage);
    var current = 0;

    var show = function (page) {
      current = page;
      rows.forEach(function (row, i) {
        row.hidden = Math.floor(i / perPage) !== page;
      });
      Array.prototype.forEach.call(pager.children, function (btn, i) {
        btn.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
    };

    for (var p = 0; p < pages; p++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pm-work__page';
      btn.textContent = String(p + 1);
      btn.setAttribute('aria-label', 'Page ' + (p + 1));
      (function (page) {
        btn.addEventListener('click', function () {
          show(page);
          // Land on the first row of the new page, not wherever the pager was.
          panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      })(p);
      pager.appendChild(btn);
    }

    pager.hidden = false;
    show(0);
  });
})();
